import { faGithub } from "@fortawesome/free-brands-svg-icons"
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import "./ProjectLinks.scss"

export const ProjectLinks = ({ project }) => {
    if (project === null) return <p></p>
    const { liveDemo, codeLink } = project;

    return (
        <ul className="projectlinks">
            <li className="projectlinks__item">
                <a
                    href={liveDemo.urlLiveDemo}
                    aria-label={liveDemo.ariaLabel}
                    title={liveDemo.tooltip}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="projectlinks__link projectlinks__link--btn"
                >
                    <i className="projectlinks__icon">
                        <FontAwesomeIcon icon={faExternalLinkAlt} />
                    </i>
                    Demo Live
                </a>
            </li>
            <li className="projectlinks__item">
                <a
                    href={codeLink.urlRepo}
                    aria-label={codeLink.ariaLabel}
                    title={codeLink.tooltip}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="projectlinks__link projectlinks__link--outline"
                >
                    <i className="projectlinks__icon">
                        <FontAwesomeIcon icon={faGithub} />
                    </i>
                    Github code & docs
                </a>
            </li>
        </ul>
    )
}